import { z } from 'zod'

import {
  MessageSchema,
  MessageSequenceSchema,
} from '@/modules/message/service/message-service.tsx'

export const FollowUpSchema = z.object({
  sendAfterMinutes: z.number().int('Time must be more then 0'),
  sendIfNotSeenParentMessage: z.boolean(),
  sequence: MessageSequenceSchema,
  statistics: z.object({
    totalPPVBought: z.number(),
    totalReads: z.number(),
    totalSent: z.number(),
    totalResponses: z.number(),
  }),
})

export const FollowUpRequestBodySchema = z.object({
  sendAfterMinutes: z.number().int('Time must be more then 0'),
  sendIfNotSeenParentMessage: z.boolean(),
  messages: MessageSchema.array(),
})

export type FollowUp = z.infer<typeof FollowUpSchema>
